import { OpenAPI } from 'app/API';
import type { $OpenApiTs } from 'app/API/models';
import type { CancelablePromise } from 'app/API/core/CancelablePromise';
import { request } from 'app/API/core/request';
import type { TCall } from 'app/queries/types/TCall';

export type TResubmitAdminJobVariables = $OpenApiTs['/api/admin/jobs/jobs/{jobId}/resubmit-by-admin']['post']['req'] & {
  noShow: boolean;
};

const resubmitAdminJob = ({ jobId, noShow, ...query }: TResubmitAdminJobVariables): CancelablePromise<void> =>
  request(OpenAPI, {
    method: 'POST',
    url: '/api/admin/jobs/jobs/{jobId}/resubmit-by-admin',
    path: { jobId },
    query: { ...query, noShow },
  });

export const createResubmitAdminJobMutationFn = (call: TCall) => (variables: TResubmitAdminJobVariables) =>
  call(() => resubmitAdminJob(variables));
